import type { HblIUsePromoDetail } from '@/utils/types'
import {request as __request} from "@hubblecommerce/hubble/platforms/shopware/request";
import {OpenAPI} from "@hubblecommerce/hubble/platforms/shopware/api-client";
import {ref} from "vue";
import {hblMapPromo, hblMapPromoDetail} from '#imports'

export const usePromo = function (): HblIUsePromoDetail {
    const loading: Ref<boolean> = ref(false)
    const error: Ref = ref(false)
    const promobarData: Ref<any | null> = ref(null);

    function isPromotionValid(promotion: any): boolean {
        const now = new Date();

        const validFrom = promotion?.validFrom;
        const validUntil = promotion?.validUntil;

        const startDate = validFrom ? new Date(validFrom) : null;
        const endDate = validUntil ? new Date(validUntil) : null;

        if (!startDate && !endDate) return true;

        return (!startDate || startDate <= now) && (!endDate || endDate > now);
    }

    async function fetchPromobarData() {
        loading.value = true;

        try {
            const storedElementRaw = localStorage.getItem('promobarElement');
            const parsedElement = storedElementRaw ? JSON.parse(storedElementRaw) : null;

            const response: any = await __request(OpenAPI, {
                method: 'GET',
                url: '/promobar'
            });

            if (response.elements && response.elements.length > 0) {
                const now = new Date();

                const validElements = response.elements.filter(element => {
                    const promotion = element.extensions.promotion;
                    const validFrom = promotion?.validFrom;
                    const validUntil = promotion?.validUntil;

                    if (validFrom === null && validUntil === null) return true;

                    const startDate = validFrom ? new Date(validFrom) : null;
                    const endDate = validUntil ? new Date(validUntil) : null;

                    return (!startDate || startDate <= now) && (!endDate || endDate > now);
                });

                if (validElements.length === 0) {
                    error.value = 'No valid promotions found';
                    return;
                }

                if (parsedElement) {
                    const match = validElements.find(el => el.id === parsedElement.id);

                    if (match) {
                        const promotion = match.extensions.promotion;

                        const validFrom = promotion?.validFrom;
                        const validUntil = promotion?.validUntil;

                        if (
                            parsedElement.validFrom !== validFrom ||
                            parsedElement.validUntil !== validUntil
                        ) {
                            const updated = hblMapPromo(match);
                            localStorage.setItem('promobarElement', JSON.stringify(updated));
                            promobarData.value = updated;
                        } else {
                            promobarData.value = parsedElement;
                        }

                        loading.value = false;
                        return;
                    } else {
                        localStorage.removeItem('promobarElement');
                    }
                }

                const randomElement = validElements[Math.floor(Math.random() * validElements.length)];
                const mappedData = hblMapPromo(randomElement);

                localStorage.setItem('promobarElement', JSON.stringify(mappedData));
                promobarData.value = mappedData;
            }

        } catch (e) {
            console.error(e);
            error.value = 'Failed to fetch promobar data';
        } finally {
            loading.value = false;
        }
    }

    async function getPromotion(productId: any) {
        loading.value = true
        error.value = false

        try {
            const response: any = await __request(OpenAPI, {
                method: 'GET',
                url: '/product/{productId}/promotion',
                path: {
                    // @ts-ignore
                    productId: productId
                }
            });

            if (response.elements && response.elements.length > 0) {
                const now = ref(new Date());

                // @ts-ignore
                const validElements = response.elements.filter(element => {
                    const validFrom = element.extensions.promotion.validFrom;
                    const validUntil = element.extensions.promotion.validUntil;

                    if (validFrom === null && validUntil === null) {
                        return true;
                    }

                    const startDate = validFrom ? new Date(validFrom) : null;
                    const endDate = validUntil ? new Date(validUntil) : null;

                    return startDate && endDate
                        ? startDate <= now.value && endDate > now.value
                        : false;
                });

                let mappedData = null
                if(validElements?.[0]) {
                    mappedData = hblMapPromoDetail(validElements[0]);
                }

                loading.value = false;

                return mappedData
            }
        } catch (e) {
            console.log(e);
        }
    }

    return {
        getPromotion,
        fetchPromobarData,
        promobarData,
        loading,
        error
    }
}
